import type { FC, RefObject } from 'react';
import { useSelector } from 'react-redux';
import { seriallyClearQuotaCleanerFeature } from 'reactApp/appHelpers/featuresHelpers/features/quotaCleanerSeriallyClear';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { STORAGE_CONFIG } from 'reactApp/modules/storage/storage.config';
import {
    getCurrentTotalCount,
    getItemsTotalCount,
    getItemsTotalSize,
    getStorageSelectedItems,
} from 'reactApp/modules/storage/storage.selectors';
import type { CloudItem, EStorageType } from 'reactApp/modules/storage/storage.types';
import type { RootState } from 'reactApp/store';
import { getQuotaDeleteItem } from 'reactApp/ui/Mobile/ActionsBar/customActions/getQuotaDeleteItem';

export type ActionbarItemProps = Record<string, any> & { parentRef?: RefObject<HTMLElement> };
export type ActionbarItem = FC<ActionbarItemProps>;
export type TActionbarItem = { Item?: ActionbarItem | null; itemProps?: ActionbarItemProps };
export const useCustomActions = ({ storage }: { storage: EStorageType }) => {
    const customActions: TActionbarItem[] = [];
    const items: CloudItem[] = useSelector((state: RootState) => getStorageSelectedItems(state, storage)) as CloudItem[];
    const currentStorage = useSelector(getCurrentStorage);
    const settings = STORAGE_CONFIG[storage || currentStorage];

    const totalItemsCount = useSelector((state: RootState) => getCurrentTotalCount(state, undefined, undefined));
    const selectedCount = items.length;
    const allSelected = !!selectedCount && selectedCount === totalItemsCount;
    const itemsTotalSize = useSelector((state: RootState) => getItemsTotalSize(state));
    const itemsTotalLength = useSelector((state: RootState) => getItemsTotalCount(state));

    if (!settings) {
        return { customActions };
    }

    if (settings.quotaCleanerDelete) {
        customActions.push(
            getQuotaDeleteItem(
                storage,
                items,
                seriallyClearQuotaCleanerFeature && allSelected && itemsTotalSize ? itemsTotalSize : undefined,
                seriallyClearQuotaCleanerFeature && allSelected && itemsTotalLength ? itemsTotalLength : undefined
            )
        );
    }

    return { customActions };
};
